import { fetchPost, fetchPut, fetchGet } from '@/utils/request'

export function getHotlinesall (query) {
    return fetchGet('/gateway/v1/hotlines/all', query)
}
export function getHotlines (query) {
    return fetchGet('/gateway/v1/hotlines', query)
}
export function getHotlinesUse(query) {
    return fetchGet('/gateway/v1/hotlines/used', query)
}

export function getHotlinesForBind (query) {
    return fetchGet('/gateway/v1/hotlines/for-bind', query)
}

export function getFactorCunstomer (id, query) {
    return fetchGet('/gateway/v1/factors/'+id+'/customers', query)
}

export function getCunstomerTelephones(id,query) {
    return fetchGet('/gateway/v1/customers/'+id+'/telephones', query)
}

export function getCunstomerHotlines (id,query) {
    return fetchGet('/gateway/v1/customers/'+id+'/customer-hotlines', query)
}

export function editHotlinesStatus(id,query) {
    return fetchPut('/gateway/v1/hotlines/'+id+'/status', query)
}

export function getTelephones(id,query) {
    return fetchGet('/gateway/v1/hotlines/'+id+'/telephones', query)
}

export function editHotlines(id,query) {
    return fetchPut('/gateway/v1/hotlines/'+id+'/edit', query)
}

export function editCunstomerHotlinesStatus(id,query) {
    return fetchPut('/gateway/v1/customer-hotline/'+id+'/status', query)
}
export function CunstomerHotlinesrescission(id,query) {
    return fetchPut('/gateway/v1/customer-hotline/'+id+'/rescission', query)
}
export function getChargeEditLogs (query) { //站点最低消费编辑记录
    return fetchGet('/gateway/v1/customer-hotline/logs', query)
}
export function getCallrecord (query) {
    return fetchGet('/gateway/v1/call-record', query)
}

export function getSiteReport (query) {
    return fetchGet('/gateway/v1/call-record/site-report', query)
}
export function getCallrecordLog (id,query) {
    return fetchGet('/gateway/v1/call-record/'+id+'/call-log', query)
}

export function getCallrecordVoice (id,query) {
    return fetchGet('/gateway/v1/call-record/'+id+'/voice', query)
}

export function getVoiceUrl (id) {
    return '/gateway/v1/call-record/'+id+'/voice'
}

export function addBlackList (query) {
    return fetchPost('/gateway/v1/block-list', query)
}

// 获取400服务提供商
export function getProviders (query) {
    return fetchGet('/gateway/v1/hotline/providers', query)
}
// 根据服务提供商id添加400大号
export function createHotline (providerId, query) {
    return fetchPost('/gateway/v1/hotlines/' + providerId + '/create', query)
}
